import { __read } from "tslib";
import { getFromPath } from '@keen.io/charts-utils';
export var calculatePercentDifference = function (previousValue, currentValue) { return (previousValue === 0 ? 0 : (currentValue / previousValue) * 100 - 100); };
export var calculateDifference = function (previousValue, currentValue, usePercentage) {
    if (usePercentage) {
        var value = calculatePercentDifference(previousValue, currentValue);
        return value % 1 === 0 ? value : Number(value.toFixed(2));
    }
    return currentValue - previousValue;
};
export var setStatus = function (previousValue, currentValue) {
    if (previousValue === currentValue)
        return 'static';
    if (currentValue > previousValue)
        return 'increase';
    return 'decrease';
};
export var generateMetric = function (_a) {
    var type = _a.type, keys = _a.keys, data = _a.data, usePercentDifference = _a.usePercentDifference;
    var _b = __read(keys, 1), keyName = _b[0];
    var seriesLength = data.length;
    var hasMultipleResults = seriesLength > 1;
    if (hasMultipleResults && type !== 'simple') {
        var previousValue = getFromPath(data, [seriesLength - 2, keyName]);
        var currentValue = getFromPath(data, [seriesLength - 1, keyName]);
        var usePercentage = usePercentDifference && type === 'difference';
        var valueDifference = calculateDifference(previousValue, currentValue, usePercentage);
        return {
            value: currentValue,
            previousValue: previousValue,
            difference: {
                value: Math.abs(valueDifference),
                status: setStatus(previousValue, currentValue),
            },
        };
    }
    var metricData = data[data.length - 1];
    return {
        value: metricData[keyName],
    };
};
